export const checksums = {
  "content": "v3.5.0--v-NKK3iQq2t0PT6kMcaeqwxvicg3aLBd6OA5vFPswcE",
  "blog": "v3.5.0--1eZopCq7iISLSXGjHQ70g2vzoZC1R2D4508FsGLGU28"
}
export const checksumsStructure = {
  "content": "bgIYhpjRuV8zbHJE_CfelwKpJ_Td6YuGJwixiek8lmI",
  "blog": "ShoBHxk-sHqNITkn8lC4uMUMAJRoXPvZBn4GVcp9dmI"
}

export const tables = {
  "content": "_content_content",
  "blog": "_content_blog",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "archived": "boolean",
      "author": "json",
      "body": "json",
      "categories": "json",
      "category": "string",
      "date": "string",
      "description": "string",
      "draft": "boolean",
      "evidenceSources": "json",
      "evidence_sources": "json",
      "excerpt": "string",
      "extension": "string",
      "faq": "json",
      "focusQuestion": "string",
      "focus_question": "string",
      "hero_image": "string",
      "hero_image_alt": "string",
      "last_updated": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "product": "string",
      "publishedAt": "string",
      "readingTime": "number",
      "reading_time": "number",
      "seo": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}